import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import CloseIcon from '@mui/icons-material/Close';
import FlexBox from 'components/common/FlexBox';
import InsuranceConventionCoefficientEditContainer from './InsuranceConventionCoefficientEditContainer';
import { editCoefficientVar } from 'features/insuranceConventions/edit/variables';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

export const actionsSlotId = 'coefficients-card-actions-slot';

const InsuranceConventionCoefficientModalComponent = ({ coefficients }) => {
  const { t } = useTranslation();
  const editCoefficient = useReactiveVar(editCoefficientVar);

  const handleClose = useCallback(() => {
    editCoefficientVar({ open: false });
  }, []);

  return (
    <Dialog
      id={`coefficient_${editCoefficient?.coefficient?.insuranceConventionAdditionalDataId}`}
      open={editCoefficient.open}
      fullWidth
      maxWidth='lg'
      TransitionProps={{ exit: false }}
    >
      <Grid container sx={{ p: 1 }}>
        <DialogTitle color='primary' fontWeight='bold' variant='subtitle1'>
          {editCoefficient?.coefficient?.insuranceConventionAdditionalDataId
            ? t('InsuranceConventions.Details.Coefficients.EditCoefficient')
            : t('InsuranceConventions.Details.Coefficients.AddCoefficient')}
        </DialogTitle>
        <FlexBox grow={1} justifyContent='end'>
          <DialogActions>
            <Grid id={actionsSlotId} />
            <IconButton color='primary' variant='text' tooltip={t('Close')} size='tiny' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </FlexBox>
      </Grid>
      <DialogContent sx={{ paddingTop: 0 }}>
        {editCoefficient.open && <InsuranceConventionCoefficientEditContainer coefficients={coefficients} />}
      </DialogContent>
    </Dialog>
  );
};

InsuranceConventionCoefficientModalComponent.propTypes = {
  coefficients: PropTypes.array
};

export default InsuranceConventionCoefficientModalComponent;
